<div class="row mt-5">
    <div class="d-flex justify-content-between">
        <div>
            <h2 class="titleppal">{{this.TituloOpcionMenu()}}</h2>
            <div class="line">
                <div class="line2"></div>
            </div>
        </div>
        <div class="botoncerrar">
            <a type="button" (click)="CancelarRegistro()">
                <mat-icon aria-hidden="false">close</mat-icon>
            </a>
        </div>
    </div>
    <div class="d-flex flex-column filtrosTable" autocomplete="off">
        <h2 class="titleppalopciones">Usuarios, grupos y roles</h2>
        <div class="linenegra">
        </div>

        <div class="row d-flex flex-wrap contenedorprincipalopciones">

            <div class="contenedoropcion" (click)="AbrirOpcionConfiguracion('MaestrosRolesDominioComponent')">
                <div>
                    <div class="d-flex justify-content-center">
                        <div class="contenedoricono">
                            <mat-icon class="iconoherramienta">settings</mat-icon>
                        </div>
                    </div>
                    <div class="d-flex justify-content-center mt-3">
                        <span class="tituloopcion">Rol de dominio</span>
                    </div>
                </div>
            </div>

            <div class="contenedoropcion" (click)="AbrirOpcionConfiguracion('MaestrosRolesComponent')">
                <div>
                    <div class="d-flex justify-content-center">
                        <div class="contenedoricono">
                            <mat-icon class="iconoherramienta">settings</mat-icon>
                        </div>
                    </div>
                    <div class="d-flex justify-content-center mt-3">
                        <span class="tituloopcion">Rol de aplicación</span>
                    </div>
                </div>
            </div>

            <div class="contenedoropcion" (click)="AbrirOpcionConfiguracion('MaestrosGruposComponent')">
                <div>
                    <div class="d-flex justify-content-center">
                        <div class="contenedoricono">
                            <mat-icon class="iconoherramienta">settings</mat-icon>
                        </div>
                    </div>
                    <div class="d-flex justify-content-center mt-3">
                        <span class="tituloopcion">Grupos</span>
                    </div>
                </div>
            </div>

            <div class="contenedoropcion" (click)="AbrirOpcionConfiguracion('MaestrosUsuariosComponent')">
                <div>
                    <div class="d-flex justify-content-center">
                        <div class="contenedoricono">
                            <mat-icon class="iconoherramienta">settings</mat-icon>
                        </div>
                    </div>
                    <div class="d-flex justify-content-center mt-3">
                        <span class="tituloopcion">Usuarios</span>
                    </div>
                </div>
            </div>

            <div class="contenedoropcion" (click)="AbrirOpcionConfiguracion('MaestrosMatrizAccesoComponent')">
                <div>
                    <div class="d-flex justify-content-center">
                        <div class="contenedoricono">
                            <mat-icon class="iconoherramienta">settings</mat-icon>
                        </div>
                    </div>
                    <div class="d-flex justify-content-center mt-3">
                        <span class="tituloopcion">Matriz de acceso</span>
                    </div>
                </div>
            </div>

            <div class="contenedoropcion" (click)="AbrirOpcionConfiguracion('MaestrosDashboardComponent')">
                <div>
                    <div class="d-flex justify-content-center">
                        <div class="contenedoricono">
                            <mat-icon class="iconoherramienta">settings</mat-icon>
                        </div>
                    </div>
                    <div class="d-flex justify-content-center mt-3">
                        <span class="tituloopcion">Dashboard</span>
                    </div>
                </div>
            </div>

            <div class="contenedoropcion" (click)="AbrirOpcionConfiguracion('MaestrosMenuComponent')">
                <div>
                    <div class="d-flex justify-content-center">
                        <div class="contenedoricono">
                            <mat-icon class="iconoherramienta">settings</mat-icon>
                        </div>
                    </div>
                    <div class="d-flex justify-content-center mt-3">
                        <span class="tituloopcion">Menú</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="d-flex flex-column filtrosTable mt-3" autocomplete="off">
        <h2 class="titleppalopciones">Administración</h2>
        <div class="linenegra col-lg-12 col-md-12 col-12">
        </div>

        <div class="row d-flex flex-wrap contenedorprincipalopciones">

            <div class="contenedoropcion" (click)="AbrirOpcionConfiguracion('MaestrosProvinciasComponent')">
                <div>
                    <div class="d-flex justify-content-center">
                        <button class="contenedoricono">
                            <mat-icon class="iconoherramienta">settings</mat-icon>
                        </button>
                    </div>
                    <div class="d-flex justify-content-center mt-3">
                        <span class="tituloopcion">Departamento y ciudad</span>
                    </div>
                </div>
            </div>

            <div class="contenedoropcion" (click)="AbrirOpcionConfiguracion('MaestrosSectorComponent')">
                <div>
                    <div class="d-flex justify-content-center">
                        <div class="contenedoricono">
                            <mat-icon class="iconoherramienta">settings</mat-icon>
                        </div>
                    </div>
                    <div class="d-flex justify-content-center mt-3">
                        <span class="tituloopcion">Sector</span>
                    </div>
                </div>
            </div>

            <div class="contenedoropcion" (click)="AbrirOpcionConfiguracion('MaestrosAliadosComponent')">
                <div>
                    <div class="d-flex justify-content-center">
                        <div class="contenedoricono">
                            <mat-icon class="iconoherramienta">settings</mat-icon>
                        </div>
                    </div>
                    <div class="d-flex justify-content-center mt-3">
                        <span class="tituloopcion">Aliado</span>
                    </div>
                </div>
            </div>

            <div class="contenedoropcion" (click)="AbrirOpcionConfiguracion('MaestrosProductosComponent')">
                <div>
                    <div class="d-flex justify-content-center">
                        <div class="contenedoricono">
                            <mat-icon class="iconoherramienta">settings</mat-icon>
                        </div>
                    </div>
                    <div class="d-flex justify-content-center mt-3">
                        <span class="tituloopcion">Programas</span>
                    </div>
                </div>
            </div>

            <div class="contenedoropcion" (click)="AbrirOpcionConfiguracion('MaestrosMarcasComponent')">
                <div>
                    <div class="d-flex justify-content-center">
                        <div class="contenedoricono">
                            <mat-icon class="iconoherramienta">settings</mat-icon>
                        </div>
                    </div>
                    <div class="d-flex justify-content-center mt-3">
                        <span class="tituloopcion">Marcas</span>
                    </div>
                </div>
            </div>

            <div class="contenedoropcion" (click)="AbrirOpcionConfiguracion('MaestrosConfiguracionComercializacionComponent')">
                <div>
                    <div class="d-flex justify-content-center">
                        <div class="contenedoricono">
                            <mat-icon class="iconoherramienta">settings</mat-icon>
                        </div>
                    </div>
                    <div class="d-flex justify-content-center mt-3">
                        <span class="tituloopcion">Configuración comercialización</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="d-flex flex-column filtrosTable mt-3" autocomplete="off">
        <h2 class="titleppalopciones">Procesos & automatización</h2>
        <div class="linenegra">
        </div>

        <div class="row d-flex flex-wrap contenedorprincipalopciones">

            <div class="contenedoropcion" (click)="AbrirOpcionConfiguracion('MaestrosCargasArchivosComponent')">
                <div>
                    <div class="d-flex justify-content-center">
                        <div class="contenedoricono">
                            <mat-icon class="iconoherramienta">settings</mat-icon>
                        </div>
                    </div>
                    <div class="d-flex justify-content-center mt-3">
                        <span class="tituloopcion">Carga de archivos</span>
                    </div>
                </div>
            </div>

            <div class="contenedoropcion" (click)="AbrirOpcionConfiguracion('MaestrosCargaApiClientesAseguradosComponent')">
                <div>
                    <div class="d-flex justify-content-center">
                        <div class="contenedoricono">
                            <mat-icon class="iconoherramienta">settings</mat-icon>
                        </div>
                    </div>
                    <div class="d-flex justify-content-center mt-3">
                        <span class="tituloopcion">Carga de API</span>
                    </div>
                </div>
            </div>

            <div class="contenedoropcion" (click)="AbrirOpcionConfiguracion('MaestrosConsultasComponent')">
                <div>
                    <div class="d-flex justify-content-center">
                        <div class="contenedoricono">
                            <mat-icon class="iconoherramienta">settings</mat-icon>
                        </div>
                    </div>
                    <div class="d-flex justify-content-center mt-3">
                        <span class="tituloopcion">Reportes</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>